/* unplugin-vue-components disabled */import __unplugin_components_2 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import __unplugin_components_1 from '/var/repos/bic-vue/src/components/configurator/ToolbarButton.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/configurator/topbar/FontSelect.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "flex items-center w-full h-full"
};
const _hoisted_2 = {
  class: "flex h-full justify-between ml-2"
};
const _hoisted_3 = {
  class: "flex items-center border-gray-500 border-r-[0.5px] border-opacity-40"
};
const _hoisted_4 = {
  class: "dropdown"
};
const _hoisted_5 = {
  class: "m-1 btn btn-square btn-sm btn-ghost"
};
const _hoisted_6 = {
  class: "h-full w-full flex flex-col"
};
const _hoisted_7 = {
  class: "p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box"
};
const _hoisted_8 = {
  class: "text-align-buttons flex items-center border-gray-500 border-r-[0.5px] border-opacity-40"
};
import { useConfigurationStore } from '@/stores/configurationModule';
import { ColorPicker } from 'vue-color-kit';

// const { t } = useI18n();

export default {
  __name: 'TextObjectEditor',
  setup(__props) {
    const $eventBus = inject('bus');
    const boldCheck = ref(false);
    const italicCheck = ref(false);
    const colorPick = ref('white');
    const configurationStore = useConfigurationStore();
    const {
      activeObjects
    } = storeToRefs(configurationStore);

    // Needed in this format
    const object = JSON.parse(JSON.stringify(activeObjects.value))[0];
    colorPick.value = object.fill;
    function handleFontWeight() {
      boldCheck.value = !boldCheck.value;
      $eventBus.$emit("bold-toggled", boldCheck.value);
    }
    function handleTextAlign(align) {
      $eventBus.$emit("text-align-changed", align);
    }
    function handleItalic() {
      italicCheck.value = !italicCheck.value;
      $eventBus.$emit("italic-toggled", italicCheck.value);
    }
    function handleColor(color) {
      const {
        r,
        g,
        b,
        a
      } = color.rgba;
      const rgbaColor = `rgba(${r}, ${g}, ${b}, ${a})`;
      colorPick.value = rgbaColor;
      $eventBus.$emit('font-color-changed', rgbaColor);
    }
    function setInputs() {
      if (activeObjects.value.length === 1) {
        boldCheck.value = object.fontWeight === 'bold';
        italicCheck.value = object.fontStyle === 'italic';
      }
    }
    onMounted(() => {
      setInputs();
    });
    watch(activeObjects, () => {
      setInputs();
    });
    return (_ctx, _cache) => {
      const _component_FontSelect = __unplugin_components_0;
      const _component_ToolbarButton = __unplugin_components_1;
      const _component_SvgIcon = __unplugin_components_2;
      const _directive_tippy = _resolveDirective("tippy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_FontSelect, {
        class: "min-w-[80px]"
      })]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_ToolbarButton, {
        class: "m-1",
        icon: "bold",
        tooltip: "Bold",
        active: _unref(boldCheck),
        onClick: handleFontWeight
      }, null, 8, ["active"]), _createVNode(_component_ToolbarButton, {
        class: "m-1",
        icon: "italic",
        tooltip: "Italic",
        active: _unref(italicCheck),
        onClick: handleItalic
      }, null, 8, ["active"]), _createElementVNode("details", _hoisted_4, [_createElementVNode("summary", _hoisted_5, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_SvgIcon, {
        class: "h-full w-full p-1 opacity-75",
        fill: "white",
        svgSymbolId: "paint-bucket"
      }), _createElementVNode("div", {
        class: "w-[80%] h-[5px] mx-auto",
        style: _normalizeStyle({
          'background-color': _unref(colorPick)
        })
      }, null, 4)])), [[_directive_tippy, {
        content: 'Text Color',
        placement: 'bottom',
        animation: 'scale-subtle',
        delay: 0,
        duration: 0
      }]])]), _createElementVNode("ul", _hoisted_7, [_createVNode(_unref(ColorPicker), {
        style: {
          "width": "220px"
        },
        theme: "dark",
        color: _unref(colorPick),
        onChangeColor: handleColor
      }, null, 8, ["color"])])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_ToolbarButton, {
        class: "m-1",
        icon: "format-align-left",
        tooltip: "Align Left",
        onClick: _cache[0] || (_cache[0] = $event => handleTextAlign('left'))
      }), _createVNode(_component_ToolbarButton, {
        class: "m-1",
        icon: "format-align-center",
        tooltip: "Align Center",
        onClick: _cache[1] || (_cache[1] = $event => handleTextAlign('center'))
      }), _createVNode(_component_ToolbarButton, {
        class: "m-1",
        icon: "format-align-right",
        tooltip: "Align Right",
        onClick: _cache[2] || (_cache[2] = $event => handleTextAlign('right'))
      })])])]);
    };
  }
};